import { render, staticRenderFns } from "./Box9.vue?vue&type=template&id=6f782dc4&scoped=true&"
import script from "./Box9.vue?vue&type=script&lang=js&"
export * from "./Box9.vue?vue&type=script&lang=js&"
import style0 from "./Box9.vue?vue&type=style&index=0&id=6f782dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f782dc4",
  null
  
)

export default component.exports